import seedrandom from 'seedrandom'
import React from 'react'

export const random = seedrandom('hello friends');

export const formatContent = (content) => {
  return content.split('\n').map(((c, index)=>(<p key={index} className={"line"}>{c}</p>)))
}

